import f from "../../../funcs";
import Marionette from "marionette";
import IconView from "./IconView";
import "classes/desktop/view/IconPlugin/Settings";


let IconsView = Marionette.CollectionView.extend("IconsView", {
    className: "tab-listener",
    initialize(params) {
        this.desktop = params.desktop;
    },

    getChildView(model) {
        return IconView.getModelPlugin(model);
    },

    childViewOptions() {
        return {
            desktop: this.desktop,
            iconsView: this
        };
    },

    getSelectedViews(params) {
        params = f.deepMixin({ without: false }, params);
        let withoutView = params.without;

        let views = [];
        this.children.each(function(view) {
            if ( view == withoutView || !view.$el.hasClass("selected") ) {
                return;
            }

            views.push(view);
        }.bind(this));

        return views;
    }
});

IconsView.IconView = IconView;

export default IconsView;
